import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Results from "./pages/Results";
import Monthly from "./pages/Monthly";
import RentACar from "./pages/RentACar";
import Fleet from "./pages/Fleet";
import International from "./pages/International";
import Network from "./pages/Network";
import Promise from "./pages/Promise";
import About from "./pages/About";
import Offers from "./pages/Offers";
import Help from "./pages/Help";
import RentersGuide from "./pages/RentersGuide";
import Booking from "./pages/Booking";
import Payment from "./pages/Payment";
import Confirmation from "./pages/Confirmation";
import Account from "./pages/Account";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import CheckIn from "./pages/CheckIn";
import ReportAccident from "./pages/ReportAccident";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import PartnerWithUs from "./pages/PartnerWithUs";
import PartnerCategory from "./pages/PartnerCategory";
import Locations from "./pages/Locations";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import SearchPage from "./pages/SearchPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";
import ModifyReservation from "./pages/ModifyReservation";
import Egmg from "./pages/Egmg";
import { WhatsAppButton } from "./components/WhatsAppButton";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/results" element={<Results />} />
      <Route path="/monthly" element={<Monthly />} />
      <Route path="/rent-a-car" element={<RentACar />} />
      <Route path="/fleet" element={<Fleet />} />
      <Route path="/international" element={<International />} />
      <Route path="/network" element={<Network />} />
      <Route path="/promise" element={<Promise />} />
      <Route path="/about" element={<About />} />
      <Route path="/offers" element={<Offers />} />
      <Route path="/help" element={<Help />} />
      <Route path="/renters-guide" element={<RentersGuide />} />
      <Route path="/modify-reservation" element={<ModifyReservation />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/confirmation/:ref" element={<Confirmation />} />
      <Route path="/account" element={<Account />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/checkin/:ref" element={<CheckIn />} />
      <Route path="/partners" element={<Navigate to="/partner-with-us" replace />} />
      <Route path="/partner-with-us" element={<PartnerWithUs />} />
      <Route path="/partner-with-us/:slug" element={<PartnerCategory />} />
      <Route path="/locations" element={<Locations />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/terms" element={<Legal doc="terms" />} />
      <Route path="/privacy" element={<Legal doc="privacy" />} />
      <Route path="/cookies" element={<Legal doc="cookies" />} />
      <Route path="/report-accident" element={<ReportAccident />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/egmg" element={<Egmg />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AppRouter />
          <WhatsAppButton />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
